<template>
    <div id="app" v-if="flag">
        <router-view class="child-view" />
        <img
            v-if="$route.path != '/' && $route.path != '/home-new' && $route.path != '/my'"
            @click="$router.push({ name: 'home-new' })"
            class="course-detail-home-button"
            src="/static/img/btn_home.svg"
            alt=""
        />
    </div>
</template>

<script>
import Interface from '@/util/interface'

export default {
    name: 'App',
    data() {
        return {
            flag: false,
            transitionName: ''
        }
    },
    watch: {
        //使用watch 监听$router的变化
        $route(to, from) {
            window.scrollTo(0, 0)
            let pvLastId = sessionStorage.getItem('PvLastId')
            if(!pvLastId){
                pvLastId = 0
            }
            Interface.pvPrint(pvLastId)
        }
    },
    methods: {
        isWeiXin() {
            var ua = window.navigator.userAgent.toLowerCase()
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                return true //是微信浏览器
            } else {
                return false //其他设备
            }
        },
        getUserInfo() {
            let user = localStorage.getItem('user')
            if (user) {
                Interface.getData('get', Interface.user.user_info).then(res => {
                    this.flag = true
                    if (res.code == 0) {
                        this.user = res.data
                    }else{
                       window.location.href = Interface.api + '/wechat/wxOauth?redirect_url=' + Interface.host + '&path=' + this.$route.path
                    }
                })
            } else {
                if (this.$route.query.category) {
                    localStorage.setItem('category', this.$route.query.category)
                }
                window.location.href = Interface.api + '/wechat/wxOauth?redirect_url=' + Interface.host + '&path=' + this.$route.path
            }
        },
        unionLogin(unionId) {
            Interface.getData('get', Interface.user.unionid_login, {
                union_id: unionId,
                path:this.$route.path,
            }).then(res => {
                if (res.code === 0 || res.code === 1) {
                    localStorage.setItem('user', JSON.stringify(res.data.user))
                    localStorage.setItem('access_token', res.data.access_token)
                    localStorage.setItem('user_id', res.data.user.id)
                    localStorage.setItem('uuid', res.data.user.uuid)
                } else {
                    this.error = true
                    if (this.$route.query.category) {
                        localStorage.setItem('category', this.$route.query.category)
                    }
                    window.location.href = Interface.api + '/wechat/wxOauth?redirect_url=' + Interface.host + '&path=' + this.$route.path
                }
                this.$router.push({
                    path: this.$route.path
                })
                this.flag = true
            })
        },
        getUserInfoByUUID() {
            let uuid = localStorage.getItem('uuid')
            if (!uuid) {
                uuid = ''
            }
            Interface.getData('get', Interface.user.uuid_login, {
                uuid: uuid,
                path:this.$route.path
            }).then(res => {
                if (res.code === 0 || res.code === 1) {
                    localStorage.setItem('user', JSON.stringify(res.data.user))
                    localStorage.setItem('access_token', res.data.access_token)
                    localStorage.setItem('user_id', res.data.user.id)
                    localStorage.setItem('uuid', res.data.user.uuid)
                } else {
                    this.error = true
                    this.$toast.fail(res.message)
                }
                this.$router.push({
                    path: this.$route.path
                })
                this.flag = true
            })
        }
    },
    beforeMount() {

        // 适配pc
        let width = window.screen.width *0.24
        let height = window.screen.height *0.78
        let userAgentInfo = navigator.userAgent;
        let Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");//pc
        if (!Agents.some(item => userAgentInfo.toLowerCase().includes(item.toLowerCase())) &&!(self.frameElement && self.frameElement.tagName == "IFRAME")) {
            let ifrTag = document.createElement("iframe");document.body.innerHTML = "";ifrTag.setAttribute("src", location.href);
            let styleObj = {width: width+"px",height: height + "px",marginTop:"7px",position: "absolute",left: "50%",transform: "translateX(-50%)",border:"1px solid #c2c2c2",sandbox:"allow-same-origin allow-forms",webkitScrollbar:"none"}
            Object.entries(styleObj).forEach(([key, value]) => {ifrTag.style[key] = value;});
            document.body.append(ifrTag);
        }

        if (this.$route.query.search_channel > 0) {
            localStorage.setItem('search_channel', this.$route.query.search_channel)
        }


        /*if (!navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
          if (window.location.href.indexOf('live-detail') > 0 && typeof this.$route.query.openid == 'undefined') {
            window.location.href = Interface.api + "/wechat/webWxOauth?redirect_url=" + Interface.web_host + "&path=" + this.$route.path
            return
          }else if (window.location.href.indexOf('live-detail-home') > 0 && typeof this.$route.query.openid == 'undefined') {
            window.location.href = Interface.api + "/wechat/webWxOauth?redirect_url=" + Interface.web_host + "&path=" + this.$route.path
            return
          }
        }*/

        if (this.$route.query.search_channel > 0) {
            localStorage.setItem('search_channel', this.$route.query.search_channel)
        }

        // unionId 登录
        let union_id = localStorage.getItem('union_id')
        if (this.$route.query.union_id != undefined) {
            localStorage.setItem('openid', this.$route.query.open_id)
            localStorage.setItem('union_id', this.$route.query.union_id)
            this.unionLogin(this.$route.query.union_id)
        }else if (union_id && union_id != '') {
            this.unionLogin(union_id)
        }else{
            if (this.isWeiXin()) {
                this.getUserInfo()
            } else {
                this.getUserInfoByUUID()
            }
        }
        Interface.pvPrint(0)
    }
}
</script>
<style>
html,
body,
#app {
    color: #333333;
    font-family: Arial, Helvetica, 'STHeiti STXihei', 'Microsoft YaHei', Tohoma, sans-serif;
    /* ios 限制微信更改字体大小 */
    -webkit-text-size-adjust: 100% !important;overflow-y: overlay;

}
::-webkit-scrollbar {
    display: none;
}

.van-grid .van-icon__image {
    width: 20px;
    height: 20px;
}
.clear {
    clear: both;
}

.page {
    min-height: 100vh;
    padding-bottom: 60px;
}

.van-swipe-item {
    text-align: center;
}

iframe {
    height: inherit;
    width: inherit;
}

/** { touch-action: pan-y; }*/
p {
    line-height: 1.8;
    margin: 0;
    max-width: 100%;
}

p img {
    max-width: 100% !important;
}

p video {
    max-width: 100%;
}

.global-back {
    position: fixed;
    right: 12px;
    bottom: 90px;
    text-align: center;
    width: 48px;
    box-sizing: border-box;
    height: 48px;
    color: #222222;
    font-size: 10px;
    border-radius: 100%;
    z-index: 999;
}

.course-detail-home-button {
    position: fixed;
    bottom: 136px;
    right: 0px;
    z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/App.vue